/**
 * Shared AI tool name + output types.
 *
 * The frontend consumes streamed assistant tool parts emitted by the
 * backend's AI provider. Keeping the tool-name discriminator and the
 * output shape in one place stops the consumer from drifting against
 * the producer (and removes the `as` casts that used to live at the
 * call site in AiChatArea).
 *
 * Runtime zod schemas live in the frontend (apps/frontend) since only
 * the frontend needs them and it owns the zod dependency.
 *
 * Source of truth: apps/backend/src/services/ai-tools/*.tool.ts.
 */

export const START_EXPERT_CHAT_TOOL = "startExpertChat" as const
export const START_EXPERT_CHAT_PART_TYPE = `tool-${START_EXPERT_CHAT_TOOL}` as const

export interface StartExpertChatSuccess {
  conversationId: string
  deepLink: string
  name: string
}

export interface StartExpertChatFailure {
  conversationId: null
  error: string
}

export type StartExpertChatOutput = StartExpertChatSuccess | StartExpertChatFailure

// --- Onboarding ritual tool ---

export const GET_ONBOARDING_RITUAL_TOOL = "getOnboardingRitual" as const
export const GET_ONBOARDING_RITUAL_PART_TYPE = `tool-${GET_ONBOARDING_RITUAL_TOOL}` as const

export interface OnboardingRitualOrganizer {
  name: string
  handle: string
  avatarAsset: string
}

export interface OnboardingRitual {
  id: string
  title: string
  description: string
  intention: string | null
  ritualType: string
  duration: string
  durationType: string
  memberCount: number
  organizers: OnboardingRitualOrganizer[]
  coverImageAsset: string
}

export interface GetOnboardingRitualSuccess {
  ritual: OnboardingRitual
}

export interface GetOnboardingRitualFailure {
  ritual: null
  error: string
}

export type GetOnboardingRitualOutput = GetOnboardingRitualSuccess | GetOnboardingRitualFailure
